import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import logoImg from '../img/newlogo.png';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [resultMessage, setResultMessage] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setResultMessage(null);

        try {
            const auth = getAuth();
            const actionCodeSettings = {
                url: process.env.NODE_ENV === 'development'
                    ? 'http://localhost:3000/__/auth/action'
                    : 'https://transferisok.com/__/auth/action',
                handleCodeInApp: true
            };

            await sendPasswordResetEmail(auth, email, actionCodeSettings);
            setResultMessage({
                status: 'success',
                message: 'Se ha enviado un correo con las instrucciones para restablecer tu contraseña.'
            });
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            console.error('Error:', error);
            let errorMessage;

            switch (error.code) {
                case 'auth/user-not-found':
                    errorMessage = `La cuenta de email ingresada no se encuentra registrada en la aplicación. 
                        <a href="/registro" class="error-link">Registrate</a> para poder ingresar a la aplicación. 
                        O comunicate con el administrador de la cuenta para que te cree un usuario con rol operador`;
                    break;
                case 'auth/invalid-email':
                    errorMessage = 'Email inválido.';
                    break;
                default:
                    errorMessage = 'Error al enviar el correo. Por favor, intenta nuevamente.';
            }

            setResultMessage({
                status: 'error',
                message: errorMessage
            });
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <img src={logoImg} alt="Logo" className="login-logo" />
                <h2>Recuperá tu contraseña</h2>

                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="email"
                        placeholder="Ingresá tu email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="login-input"
                        required
                    />
                    <button type="submit" className="login-button">
                        Enviar correo de recuperación
                    </button>
                </form>

                <button
                    onClick={() => navigate('/login')}
                    className="back-button"
                >
                    Volver al inicio de sesión
                </button>

                {resultMessage && (
                    <div
                        className={`message ${resultMessage.status}`}
                        dangerouslySetInnerHTML={{ __html: resultMessage.message }}
                    />
                )}
            </div>
        </div>
    );
}

export default ForgotPassword; 